import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  value: false,
  status: 'idle',
};

export const copyLeagueSlice = createSlice({
  name: 'copyLeague',
  initialState,

  reducers: {
    setCopyLeague: (state, action) => {
        state.value = action.payload;
    },
  },
});

export const { setCopyLeague } = copyLeagueSlice.actions;

export const copyLeague = (state) => state.copyLeague.value;

export default copyLeagueSlice.reducer;
